import client from './api-client';
export const getConfiguracionForm18 = async(query) => {
    try {
        
        const response = await client.get(`cfg-forms?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                cfg_form18: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getGrillaBusqueda = async(query) => {
    try {
        
        const response = await client.getImplicado(`getion-implicado/contacto/hitos?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                    respuestaGrillaBusqueda:response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboTipoGestion = async(query) => {
    try {
        
        const response = await client.getImplicado(`detalles?q=${query}`); 
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboTipoGestion: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getComboAmbitoGestion = async(query) => {
    try {
        
        const response = await client.getImplicado(`detalles?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                comboCAmbitoGestion: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}
export const getDatosGestion = async(query) => {
    try {
        
        const response = await client.getImplicado(`getion-implicado?q=${query}`);
        if (response.status === 200 && response.data.code === 1) {
            return {
                datosGestion: response.data.object
            }
        } else {
            throw new Error(response.data.message);
        }

    } catch(error){
        throw error;
    }
}